import { CardContainer } from '@app/components/Container/CardContainer';
import { MainContainer } from '@app/components/Container/MainContainer';
import { ModalErrorUnathenthicated } from '@app/components/ModalErrorUnathenthicated/ModalErrorUnathenthicated';
import { useModelContext } from '@app/contexts/model';
import { useStorageContext } from '@app/contexts/storage';
import { MAIN_PAGE } from '@app/enums';
import { UserData } from '@app/models/Users.model';
import { useStorageUserListContext } from '@app/modules/SelfConfig/contexts/storage';
import { useStorageUserConfigContext } from '@app/modules/UserConfig/contexts/storage';
import { Button } from '@mui/material';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';
import { CanSaveTranslation } from './views/CanSaveTranslation';
import { LanguageChoice } from './views/LanguageChoice';
import { ModalAlert } from './views/ModalAlert';
import { SaveUser } from './views/SaveUser';
import { UserLogin } from './views/UserLogin';
import { UserPassword } from './views/UserPassword';

interface IMainProps {}

export const Main: FunctionComponent<IMainProps> = observer<FunctionComponent<IMainProps>>(function (props) {
    const { usersModel } = useModelContext();

    const { userConfigStore } = useStorageUserConfigContext();
    const { usersListStore } = useStorageUserListContext();
    const { globalStorage } = useStorageContext();

    function dataAssigner() {
        let data: UserData = {
            email: '',
            password: '',
            language_source: [],
            language_target: [],
            approval: false,
            privilege: 'user'
        };

        data.email = userConfigStore.userLogin;
        data.password = userConfigStore.userPassword;
        data.language_source = userConfigStore.mainLanguagesChosenIdSet;
        data.language_target = userConfigStore.targetLanguagesChosenIdSet;
        data.approval = userConfigStore.canSaveTranslation;

        return data;
    }

    const sendFormData = (e) => {
        e.preventDefault();
        let singleUser = dataAssigner();
        usersModel.createUserData(singleUser).then(
            (r) => {
                userConfigStore.clear();
                globalStorage.openModule = MAIN_PAGE.SELF_CONFIG;
                return usersModel.findUser();
            },
            (reason) => {
                userConfigStore.handleOpenAlert();
            }
        );
    };

    return (
        <MainContainer>
            <CardContainer styles={{ margin: '0 auto' }} title={'User registration'}>
                <form onSubmit={sendFormData}>
                    <Stack spacing={2}>
                        <UserLogin />
                        <UserPassword />
                        <LanguageChoice />
                        <CanSaveTranslation />
                        <Stack justifyContent={'flex-end'} direction={'row'} spacing={2}>
                            <SaveUser />
                            {usersListStore.addUser ? (
                                <Button
                                    variant={'outlined'}
                                    onClick={() => {
                                        usersListStore.addUser = false;
                                        globalStorage.openModule = MAIN_PAGE.SELF_CONFIG;
                                        userConfigStore.clear();
                                    }}>
                                    Cancel
                                </Button>
                            ) : null}
                        </Stack>
                        <ModalErrorUnathenthicated />
                        <ModalAlert />
                    </Stack>
                </form>
            </CardContainer>
        </MainContainer>
    );
});
